<template>
  <ui-button
    block
    size="lg"
    type="submit"
    class="quiz-submit--button"
    :class="{submitted: isSubmitted}"
    :disabled="disabled || isSubmitted"
    @click="onClickSubmit"
  >
    <template v-if="!slide.stopSubmission">
      <span>{{ getButtonText() }}</span>

      <CountDownTimer v-if="hasTimeLimitOption" />
    </template>

    <template v-if="slide.stopSubmission">
      <span>{{ $t("submissionClosedButton") }}</span>
      <i class="fa fa-lock" />
    </template>
  </ui-button>
</template>

<script>
import { mapState } from 'vuex'
import UiButton from '@/components/UI/Button'
import CountDownTimer from '@/components/CountDownTimer'

export default {
  components: {
    UiButton,
    CountDownTimer,
  },
  props: {
    // This depends on the QuizForm parent component.
    // If audience haven't pick any option, 'disabled' will be true.
    disabled: {
      type: Boolean,
      required: true,
    },
    isFormSubmitted: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSubmitted: false,
    }
  },

  computed: {
    ...mapState({
      slide: (state) => state.slide,
      hasTimeLimitOption: (state) => {
        return state.slide.type === 'imageChoice' ||
       state.slide.type === 'multipleChoice' ||
       state.slide.type === 'openEnded' ||
       state.slide.type === 'wordCloud'
      },
    }),
  },

  watch: {
    isFormSubmitted(isFormSubmitted) {
      // handle when using keyboard to to trigger submit
      this.isSubmitted = isFormSubmitted
    },
  },

  mounted() {
  },
  destroyed() {

  },

  methods: {
    onClickSubmit() {
      this.isSubmitted = true
      this.$emit('submit')
    },
    getButtonText() {
      if (!this.isSubmitted) {
        return this.$t('submit')
      }
      return this.$t('submitted')
    },
  },
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.quiz-submit--button {
  height: 52px;
  width: 100%;
  left: 18px;
  top: 8px;
  border-radius: 26px;
  padding: 11px, 43px, 11px, 43px;
  font-weight: bold;
  background: $primary-color;
  &:not(.submitted):hover {
    background: darken($primary-color, 10%);
  }
  &:not(.submitted):disabled {
    background: #89befa;
  }
}

</style>
